export enum MediaType {
  Image, Video, Model3D
}
